module.exports = __webpack_public_path__ + "img/antes_despues_161.908f6c90.png";